import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL, endPointName } from 'apis/apiList';
import { logout } from 'features/auth/AuthSlice';
import { use } from 'react';
const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = getState()?.auth?.accessToken;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    headers.set('Access-Control-Allow-Origin', 'true');
    return headers;
  }
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  console.log('result3333===>', result);
  if (result.error?.status === 401) {
    api.dispatch(logout());
  }

  return result;
};

export const apiServices = createApi({
  reducerPath: 'apiServices',
  // baseQuery: fetchBaseQuery({
  //   baseUrl: BASE_URL,
  //   prepareHeaders: (headers, { getState }) => {
  //     let token = getState()?.auth?.accessToken;
  //     if (token) {
  //       headers.set('authorization', `Bearer ${token}`);
  //     }
  //     headers.set('Access-Control-Allow-Origin', 'true');
  //     return headers;
  //   }
  // }),
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getCountryList: builder.query({
      query: () => endPointName.Master.getCountry
    }),
    getStateList: builder.query({
      query: () => endPointName.Master.getState
    }),
    getDistrictList: builder.query({
      query: () => endPointName.Master.getDistrict
    }),
    getServicesList: builder.query({
      query: () => endPointName.Master.getExpertise
    }),
    getDocumentList: builder.query({
      query: () => endPointName.Master.getDocument
    }),
    getAssociateList: builder.query({
      query: () => endPointName.Master.getAssociate
    }),
    getMembershipList: builder.query({
      query: () => endPointName.Master.getMembership
    }),
    // getAdminRole: builder.query({
    //   query: () => endPointName.Master.getAdminRole
    // }),
    getAdminRole: builder.mutation({
      query: () => {
        return { url: endPointName.Master.getAdminRole, method: 'POST' };
      }
    }),
    getAdminRoleAccess: builder.query({
      query: () => endPointName.Master.getAdminRoleAccess
    }),
    getAdminModuleAccess: builder.mutation({
      // query: () => endPointName.Master.getModuleAccess
      query: () => {
        return { url: endPointName.Master.getModuleAccess, method: 'POST' };
      }
    }),
    getReligion: builder.mutation({
      query: () => {
        return { url: endPointName.Master.religion, method: 'POST' };
      }
    }),
    getCommunity: builder.mutation({
      query: () => {
        return { url: endPointName.Master.community, method: 'POST' };
      }
    }),
    getEventType: builder.mutation({
      query: () => {
        return { url: endPointName.Master.eventType, method: 'POST' };
      }
    }),
    uploadImage: builder.mutation({
      query: ({ caseNo, formData }) => {
        return {
          url: `Image/Upload/${caseNo}`,
          method: 'POST',
          body: formData
        };
      }
    }),
    volunteerInsert: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.volunteerInsert,
          method: 'POST',
          body: payload
        };
      }
    }),
    getVolunteerDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.GetVolunteerDetails,
          method: 'POST',
          body: payload
        };
      }
    }),
    adminInsert: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.adminInsertUpdate,
          method: 'POST',
          body: payload
        };
      }
    }),
    getAdminList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.adminList,
          method: 'POST',
          body: payload
        };
      }
    }),
    getAdminDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.adminDetails,
          method: 'POST',
          body: payload
        };
      }
    }),

    getProfile: builder.mutation({
      query: (payload) => {
        // let token =
        //   payload.usertype == 1
        //     ? localStorage.getItem('SSOAccessToken')
        //     : localStorage.getItem('token');
        return {
          url: endPointName.Admin.getProfile,
          method: 'POST',
          body: payload
          // headers: {
          //   'Content-Type': 'application/json',
          //   Authorization: `Bearer ${token}`,
          //   'Access-Control-Allow-Origin': 'true'
          // }
        };
      }
    }),

    getLogin: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.authorize,
          method: 'POST',
          body: payload
        };
      }
    }),
    memberInsert: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.memberInsert,
          method: 'POST',
          body: payload
        };
      }
    }),
    donationInsert: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Donation.donationInsert,
          method: 'POST',
          body: payload
        };
      }
    }),
    getVolunteerList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.volunteerList,
          method: 'POST',
          body: payload
        };
      }
    }),
    sendMobileOTP: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.sendOtp,
          method: 'POST',
          body: payload
        };
      }
    }),
    verifyMobileOTP: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.verifyOtp,
          method: 'POST',
          body: payload
        };
      }
    }),
    sendEmailOTP: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.sendEmailOtp,
          method: 'POST',
          body: payload
        };
      }
    }),
    verifyEmailOTP: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.verifyEmailOtp,
          method: 'POST',
          body: payload
        };
      }
    }),
    volunteerApproval: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.volunteerApproval,
          method: 'POST',
          body: payload
        };
      }
    }),
    memberApproval: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.memberApproval,
          method: 'POST',
          body: payload
        };
      }
    }),
    getMemberList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.memberList,
          method: 'POST',
          body: payload
        };
      }
    }),
    getMemberDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.memberDetails,
          method: 'POST',
          body: payload
        };
      }
    }),
    getBeneficiaryList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Beneficiary.GetBeneficiaryList,
          method: 'POST',
          body: payload
        };
      }
    }),
    loginMobileNoOTPSend: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.loginOTPSend,
          method: 'POST',
          body: payload
        };
      }
    }),
    volunteerUpdate: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.VolunteerUpdate,
          method: 'POST',
          body: payload
        };
      }
    }),
    loginMobileNoOTPVerify: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.loginOTPVerify,
          method: 'POST',
          body: payload
        };
      }
    }),
    volunteerListForBenficiary: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Beneficiary.getVolunteerList,
          method: 'POST',
          body: payload
        };
      }
    }),
    GetBeneficiaryDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Beneficiary.GetBeneficiaryDetails,
          method: 'POST',
          body: payload
        };
      }
    }),
    forwardVolunteer: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.forwardVolunteer,
          method: 'POST',
          body: payload
        };
      }
    }),
    forwardMember: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.forwardMember,
          method: 'POST',
          body: payload
        };
      }
    }),
    adminUpdate: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.AdminUserDataUpdate,
          method: 'POST',
          body: payload
        };
      }
    }),
    memberListBasedOnType: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.memberListBasedOnType,
          method: 'POST',
          body: payload
        };
      }
    }),
    referenceInsert: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.referenceInsert,
          method: 'POST',
          body: payload
        };
      }
    }),
    referenceList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.referenceList,
          method: 'POST',
          body: payload
        };
      }
    }),
    volunteerBecomeMemberInsert: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.volunteerBecomeMember,
          method: 'POST',
          body: payload
        };
      }
    }),
    memberBecomeVolunteerInsert: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.memberBcomeVolunteer,
          method: 'POST',
          body: payload
        };
      }
    }),
    thalassemiaInsert: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Thalassemia.ThalassemiaInsert,
          method: 'POST',
          body: payload
        };
      }
    }),
    getThalassemiaList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Thalassemia.getThalassemiaList,
          method: 'POST',
          body: payload
        };
      }
    }),
    getThalassemiaDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Thalassemia.getThalassemiaDetails,
          method: 'POST',
          body: payload
        };
      }
    }),
    donationPercentageInsert: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Donation.donationPercentageInsert,
          method: 'POST',
          body: payload
        };
      }
    }),
    percentageList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Donation.percentageList,
          method: 'POST',
          body: payload
        };
      }
    }),
    updatePercentage: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Donation.updatePercentage,
          method: 'POST',
          body: payload
        };
      }
    }),
    deletePercentage: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Donation.updatePercentage,
          method: 'POST',
          body: payload
        };
      }
    }),
    BloodDonationCampInsert: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.BloodDonation.BloodDonationCampInsert,
          method: 'POST',
          body: payload
        };
      }
    }),
    getReferenceDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.referenceDetails,
          method: 'POST',
          body: payload
        };
      }
    }),
    requestDeleteMember: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.deleteMember,
          method: 'POST',
          body: payload
        };
      }
    }),
    GetBloodDonationCampList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.BloodDonation.GetBloodDonationCampList,
          method: 'POST',
          body: payload
        };
      }
    }),
    MembershipUpdate: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.MembershipUpdate,
          method: 'POST',
          body: payload
        };
      }
    }),
    createEvent: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Event.createEvent,
          method: 'POST',
          body: payload
        };
      }
    }),
    eventList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Event.eventList,
          method: 'POST',
          body: payload
        };
      }
    }),
    eventDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Event.eventDetails,
          method: 'POST',
          body: payload
        };
      }
    }),
    createToken: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Token.createToken,
          method: 'POST',
          body: payload
        };
      }
    }),
    tokenList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Token.tokenList,
          method: 'POST',
          body: payload
        };
      }
    }),
    getTokenDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Token.tokenDetails,
          method: 'POST',
          body: payload
        };
      }
    }),
    updateToken: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Token.updateToken,
          method: 'POST',
          body: payload
        };
      }
    }),
    getTokenBeneficiaryList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Token.tokenBeneficiaryList,
          method: 'POST',
          body: payload
        };
      }
    }),
    getDonorList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Donation.getDonorList,
          method: 'POST',
          body: payload
        };
      }
    }),
    getDonorDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Donation.getDonorDetails,
          method: 'POST',
          body: payload
        };
      }
    }),
    updateEvent: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Event.updateEvent,
          method: 'POST',
          body: payload
        };
      }
    }),
    closeEvent: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Event.closeEvent,
          method: 'POST',
          body: payload
        };
      }
    }),
    tokenAsignment: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Token.tokenAsignment,
          method: 'POST',
          body: payload
        };
      }
    }),
    getEventBasedOnType: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Event.getEventbasedOnType,
          method: 'POST',
          body: payload
        };
      }
    }),
    createItemMaster: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Items.createItem,
          method: 'POST',
          body: payload
        };
      }
    }),
    getItemList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Items.itemList,
          method: 'POST',
          body: payload
        };
      }
    }),
    updateItemList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Items.updateItem,
          method: 'POST',
          body: payload
        };
      }
    }),
    delteItemFromList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Items.deleteItem,
          method: 'POST',
          body: payload
        };
      }
    }),
    beneficiaryListForTokenCreation: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Token.beneficiaryforTokenCreation,
          method: 'POST',
          body: payload
        };
      }
    }),
    forgotPass: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.forgotPassword,
          method: 'POST',
          body: payload
        };
      }
    }),
    AdminforgotPass: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.AdminforgotPassword,
          method: 'POST',
          body: payload
        };
      }
    }),
    updatePass: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.UpdatePassword,
          method: 'POST',
          body: payload
        };
      }
    }),
    LatestEventDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Event.latest_event_details,
          method: 'POST',
          body: payload
        };
      }
    }),
    LatestTokenDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Token.latest_token_details,
          method: 'POST',
          body: payload
        };
      }
    }),
    getAsignmentVolunteers: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.asignmentVolunteerList,
          method: 'POST',
          body: payload
        };
      }
    }),
    createTimesheet: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Timesheet.create,
          method: 'POST',
          body: payload
        };
      }
    }),
    getTimesheetList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Timesheet.list,
          method: 'POST',
          body: payload
        };
      }
    }),
    updateTimesheet: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Timesheet.update,
          method: 'POST',
          body: payload
        };
      }
    }),
    deleteTimesheet: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Timesheet.delete,
          method: 'POST',
          body: payload
        };
      }
    }),
    timesheetApproveReject: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Timesheet.approveReject,
          method: 'POST',
          body: payload
        };
      }
    }),
    GetDashboardData: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Dashboard.GetDashboardData,
          method: 'POST',
          body: payload
        };
      }
    }),
    getExportToExcel: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.exportToExcel,
          method: 'POST',
          body: payload,
          responseHandler: (response) => response.blob()
        };
      }
    }),
    getTranseferReference: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.transferReference,
          method: 'POST',
          body: payload
        };
      }
    }),
    getReferenceClose: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.closeReferenceNo,
          method: 'POST',
          body: payload
        };
      }
    }),
    getItemStockList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.itemStock.ItemStcok,
          method: 'POST',
          body: payload
        };
      }
    }),
    offlineMemberList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.offlineMemberList,
          method: 'POST',
          body: payload
        };
      }
    }),
    offlineMemberDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.offlineMemberDetails,
          method: 'POST',
          body: payload
        };
      }
    }),

    createOfflineMember: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.createOfflineMember,
          method: 'POST',
          body: payload
        };
      }
    }),
    updateOfflineMember: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.updateOfflineMember,
          method: 'POST',
          body: payload
        };
      }
    }),
    offlineMemberListBasedOnType: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.offlineMemberListBasedOnType,
          method: 'POST',
          body: payload
        };
      }
    }),
    offlineMemberReferenceInsert: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.offlineMemberReferenceInsert,
          method: 'POST',
          body: payload
        };
      }
    }),
    offlineMemberReferenceList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.offlineMemberReferenceList,
          method: 'POST',
          body: payload
        };
      }
    }),
    OfflineReferenceDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.referenceDetails,
          method: 'POST',
          body: payload
        };
      }
    }),
    offlineReferenceDeleteMember: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.deleteMember,
          method: 'POST',
          body: payload
        };
      }
    }),
    offlineMemberReferenceDispatch: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.ReferenceDispatch,
          method: 'POST',
          body: payload
        };
      }
    }),
    offlineMemberReferenceRecived: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.ReferenceRecieved,
          method: 'POST',
          body: payload
        };
      }
    }),
    getOfflineMemberTranseferReference: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.transferReference,
          method: 'POST',
          body: payload
        };
      }
    }),
    createRequest: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.requestPermission.createRequest,
          method: 'POST',
          body: payload
        };
      }
    }),
    requestList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.requestPermission.requestList,
          method: 'POST',
          body: payload
        };
      }
    }),
    requestUpdate: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.requestPermission.updateRequest,
          method: 'POST',
          body: payload
        };
      }
    }),
    rejectRequest: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.requestPermission.rejectRequest,
          method: 'POST',
          body: payload
        };
      }
    }),
    getOfflineReferenceClose: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.referenceClose,
          method: 'POST',
          body: payload
        };
      }
    }),
    getOfflineExportToExcel: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.exportToExcel,
          method: 'POST',
          body: payload,
          responseHandler: (response) => response.blob()
        };
      }
    }),
    deleteAdmin: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.deleteAdmin,
          method: 'POST',
          body: payload
        };
      }
    }),
    insertraining: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.insertTraining,
          method: 'POST',
          body: payload
        };
      }
    }),
    trainingList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.trainingList,
          method: 'POST',
          body: payload
        };
      }
    }),
    tagAsign: builder.mutation({
      /*************  ✨ Windsurf Command ⭐  *************/
      /**
       * Sends a POST request to the tag assignment endpoint for volunteers.
       *
       * @param {Object} payload - The data to be sent as the request body.
       * @returns {Object} The configuration object for the API request.
       */

      /*******  21ad419d-7a85-462d-be7e-08ffebe37506  *******/
      query: (payload) => {
        return {
          url: endPointName.Volunteer.tagAsign,
          method: 'POST',
          body: payload
        };
      }
    }),
    getInventoryItemDetails: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Items.inventory,
          method: 'POST',
          body: payload
        };
      }
    }),
    AdminApproval: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.adminUpdate,
          method: 'POST',
          body: payload
        };
      }
    }),
    memberPayment: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.memberPayment,
          method: 'POST',
          body: payload
        };
      }
    }),
    memberTransferStatusUpdate: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.ApproveTransferReque,
          method: 'POST',
          body: payload
        };
      }
    }),
    volunteersExportToExcel: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.volunteerExport,
          method: 'POST',
          body: payload,
          responseHandler: (response) => response.blob()
        };
      }
    }),
    memberExportToExcel: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.memberExport,
          method: 'POST',
          body: payload,
          responseHandler: (response) => response.blob()
        };
      }
    }),
    adminExportToExcel: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Admin.adminExport,
          method: 'POST',
          body: payload,
          responseHandler: (response) => response.blob()
        };
      }
    }),
    offlineReferenceExportToExcel: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.offlineReferenceExport,
          method: 'POST',
          body: payload,
          responseHandler: (response) => response.blob()
        };
      }
    }),
    offlineMemberExportToExcel: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.offlineMemberExport,
          method: 'POST',
          body: payload,
          responseHandler: (response) => response.blob()
        };
      }
    }),
    getItemListByEventId: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Event.ItemListbyEventId,
          method: 'POST',
          body: payload
        };
      }
    }),
    sendMsgToVolunteer: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.smsSend,
          method: 'POST',
          body: payload
        };
      }
    }),
    sendEmailToVolunteer: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Volunteer.smtpSend,
          method: 'POST',
          body: payload
        };
      }
    }),
    memberRenewalPayment: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.memberRenewalPayment,
          method: 'POST',
          body: payload
        };
      }
    }),
    inventryEventList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Event.inventryEventList,
          method: 'POST',
          body: payload
        };
      }
    }),
    InventryTokenList: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Token.InventryTokenList,
          method: 'POST',
          body: payload
        };
      }
    }),
    memberTransferApprovalStatusUpdate: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Member.ApproveTransferApproval,
          method: 'POST',
          body: payload
        };
      }
    }),
    closeToken: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Token.closeToken,
          method: 'POST',
          body: payload
        };
      }
    }),
    eventDropDown: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Event.eventDropdown,
          method: 'POST',
          body: payload
        };
      }
    }),
    DeleteOfflineMembers: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.offlineMember.deleteOfflineMember,
          method: 'POST',
          body: payload
        };
      }
    }),
    eventTokenExportToExcel: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Event.eventTokenExport,
          method: 'POST',
          body: payload,
          responseHandler: (response) => response.blob()
        };
      }
    }),
    updateInventory: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Items.updateStock,
          method: 'POST',
          body: payload
        };
      }
    }),
    deleteToken: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Token.deleteToken,
          method: 'POST',
          body: payload
        };
      }
    }),
    TokenExportIntoExcel: builder.mutation({
      query: (payload) => {
        return {
          url: endPointName.Token.tokenExport,
          method: 'POST',
          body: payload,
          responseHandler: (response) => response.blob()
        };
      }
    })
  })
});

export const {
  useGetCountryListQuery,
  useGetStateListQuery,
  useGetDistrictListQuery,
  useGetServicesListQuery,
  useGetDocumentListQuery,
  useGetAssociateListQuery,
  useGetCommunityMutation,
  useGetReligionMutation,
  useUploadImageMutation,
  useVolunteerInsertMutation,
  useGetMembershipListQuery,
  useGetAdminRoleMutation,
  useGetAdminRoleAccessQuery,
  useGetAdminModuleAccessMutation,
  useAdminInsertMutation,
  useGetProfileMutation,
  useGetVolunteerDetailsMutation,
  useGetLoginMutation,
  useMemberInsertMutation,
  useDonationInsertMutation,
  useGetAdminListMutation,
  useGetAdminDetailsMutation,
  useGetVolunteerListMutation,
  useSendMobileOTPMutation,
  useVerifyMobileOTPMutation,
  useSendEmailOTPMutation,
  useVerifyEmailOTPMutation,
  useVolunteerApprovalMutation,
  useMemberApprovalMutation,
  useGetMemberListMutation,
  useGetMemberDetailsMutation,
  useGetBeneficiaryListMutation,
  useVolunteerUpdateMutation,
  useLoginMobileNoOTPSendMutation,
  useLoginMobileNoOTPVerifyMutation,
  useVolunteerListForBenficiaryMutation,
  useGetBeneficiaryDetailsMutation,
  useForwardVolunteerMutation,
  useForwardMemberMutation,
  useAdminUpdateMutation,
  useMemberListBasedOnTypeMutation,
  useReferenceInsertMutation,
  useVolunteerBecomeMemberInsertMutation,
  useMemberBecomeVolunteerInsertMutation,
  useThalassemiaInsertMutation,
  useDonationPercentageInsertMutation,
  useUpdatePercentageMutation,
  useDeletePercentageMutation,
  usePercentageListMutation,
  useReferenceListMutation,
  useBloodDonationCampInsertMutation,
  useGetBloodDonationCampListMutation,
  useMembershipUpdateMutation,
  useGetReferenceDetailsMutation,
  useRequestDeleteMemberMutation,
  useGetThalassemiaListMutation,
  useGetThalassemiaDetailsMutation,
  useCreateEventMutation,
  useEventListMutation,
  useEventDetailsMutation,
  useCreateTokenMutation,
  useTokenListMutation,
  useGetTokenDetailsMutation,
  useUpdateTokenMutation,
  useGetTokenBeneficiaryListMutation,
  useGetDonorListMutation,
  useGetDonorDetailsMutation,
  useUpdateEventMutation,
  useCloseEventMutation,
  useGetEventTypeMutation,
  useTokenAsignmentMutation,
  useGetEventBasedOnTypeMutation,
  useCreateItemMasterMutation,
  useGetItemListMutation,
  useUpdateItemListMutation,
  useDelteItemFromListMutation,
  useBeneficiaryListForTokenCreationMutation,
  useForgotPassMutation,
  useUpdatePassMutation,
  useLatestEventDetailsMutation,
  useLatestTokenDetailsMutation,
  useGetAsignmentVolunteersMutation,
  useCreateTimesheetMutation,
  useGetTimesheetListMutation,
  useUpdateTimesheetMutation,
  useDeleteTimesheetMutation,
  useTimesheetApproveRejectMutation,
  useGetDashboardDataMutation,
  useGetExportToExcelMutation,
  useGetTranseferReferenceMutation,
  useGetReferenceCloseMutation,
  useGetItemStockListMutation,
  useOfflineMemberListMutation,
  useCreateOfflineMemberMutation,
  useUpdateOfflineMemberMutation,
  useOfflineMemberDetailsMutation,
  useOfflineMemberListBasedOnTypeMutation,
  useOfflineMemberReferenceInsertMutation,
  useCreateRequestMutation,
  useRequestListMutation,
  useRequestUpdateMutation,
  useRejectRequestMutation,
  useOfflineMemberReferenceListMutation,
  useOfflineReferenceDetailsMutation,
  useOfflineReferenceDeleteMemberMutation,
  useOfflineMemberReferenceDispatchMutation,
  useGetOfflineMemberTranseferReferenceMutation,
  useGetOfflineReferenceCloseMutation,
  useGetOfflineExportToExcelMutation,
  useOfflineMemberReferenceRecivedMutation,
  useAdminforgotPassMutation,
  useDeleteAdminMutation,
  useInsertrainingMutation,
  useTrainingListMutation,
  useTagAsignMutation,
  useGetInventoryItemDetailsMutation,
  useAdminApprovalMutation,
  useMemberPaymentMutation,
  useMemberTransferStatusUpdateMutation,
  useVolunteersExportToExcelMutation, // new api need add from here
  useMemberExportToExcelMutation,
  useAdminExportToExcelMutation,
  useOfflineReferenceExportToExcelMutation,
  useOfflineMemberExportToExcelMutation,
  useGetItemListByEventIdMutation,
  useSendMsgToVolunteerMutation,
  useSendEmailToVolunteerMutation,
  useMemberRenewalPaymentMutation,
  useInventryEventListMutation,
  useInventryTokenListMutation,
  useMemberTransferApprovalStatusUpdateMutation,
  useCloseTokenMutation,
  useEventDropDownMutation,
  useDeleteOfflineMembersMutation,
  useEventTokenExportToExcelMutation,
  useUpdateInventoryMutation,
  useDeleteTokenMutation,
  useTokenExportIntoExcelMutation
} = apiServices;
